import * as yup from "yup";

export function createYupSchema(schema, config) {
  const { id, code, validations = {} } = config;
  // if (code == "SalaryBankAcc" || code == "GMI" || code == "TotalWorkExp") {
  //   return schema;
  // }
  let validationType = "string";
  if (validations != null) {
    validationType = JSON.parse(validations).validationType;
    // validationType = validations.validationType;
  }
  if (!yup[validationType]) {
    return schema;
  }
  let validator = yup[validationType]();
  let localeValidations = [];
  if (validations != null) {
    localeValidations = JSON.parse(validations)["en"];
    // localeValidations =  validations[locale];
  }
  localeValidations.forEach((validation) => {
    const { params, type } = validation;
    let modifiedParams = [...params];
    modifiedParams[0] = type == "matches" ? new RegExp(params[0]) : params[0];
    if (!validator[type]) {
      return;
    }
    validator = validator[type](...modifiedParams);
  });

  schema[id] = validator;

  return schema;
}

export const cloneData = [
  {
    main: "ResCity",
    depended: "PermCity",
  },
  {
    main: "ResPIN",
    depended: "PermPin",
  },
  {
    main: "ResAddress4",
    depended: "PermAddress4",
  },
  {
    main: "ResAddress2",
    depended: "PermAddress2",
  },
  {
    main: "ResAddress1",
    depended: "PermAddress1",
  },
];

export const bajajCloneData = [
  {
    main: "currentAddressLine1",
    depended: "permanentAddressLine1",
  },
  {
    main: "currentAddressLine2",
    depended: "permanentAddressLine2",
  },
  {
    main: "currentAddressLine3",
    depended: "permanentAddressLine3",
  },
  {
    main: "zipCode",
    depended: "PermanentZipCode",
  },
  {
    main:  "currentCity",
    depended: "PermanentCity",
  },
  {
    main: "currentState",
    depended:  "PermanentState",
  },
]
